import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'nalco-refresh-loader',
    templateUrl: './refresh-loader.component.html',
    styleUrls: ['./refresh-loader.component.scss'],
    standalone: false
})
export class RefreshLoaderComponent implements OnInit {
  widthInPx = '72px';
  heightInPx = '72px';

  private _width!: number;
  private _height!: number;

  @Input() isLoading: boolean;
  @Input() set width(value: number){
    if(value){
      this._width = value;
      this.widthInPx = `${value}px`;
    }
  }
  @Input() set height(value: number){
    if(value){
      this._height = value;
      this.heightInPx = `${value}px`;
    }
  }

  constructor() { }

  ngOnInit() {
  }

}
